// dataSlice.js
import { createSlice } from "@reduxjs/toolkit";

const mainAccessData = createSlice({
  name: "mainAccessData", // Change the name of the slice here
  initialState: [],
  reducers: {
    setMainAccessData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setMainAccessData } = mainAccessData.actions;

export default mainAccessData.reducer;
